import { useRef, useState } from 'react'

import { MultiAutocomplete } from 'Components/UI/Atoms/CustomAutocomplete'
import useCustomSnackbar from 'Components/UI/Atoms/SnackBar'
import CancelConfirmButtons from 'Components/UI/Molecules/CancelConfirmButtons'
import InputsWithValidate from 'Components/UI/Molecules/InputsWithValidate'
import DialogComponent from 'Components/UI/Molecules/Modals/DialogComponent'
import { Form, Formik } from 'formik'
import { interfaces } from 'service/interfaces'

const Edit = (props) => {
  const { open, handleclose, id, editInfo, changeRender } = props
  const createDismissableSnackbar = useCustomSnackbar()
  const info = editInfo()
  const [isLoading, setIsLoading] = useState(false)
  const formSubmitRef = useRef(null)
  const handleSubmit = () => {
    formSubmitRef.current.click()
  }

  const onSubmit = async (values) => {
    setIsLoading(true)
    const body = {
      nombre: values.nombre,
      descripcion: values.descripcion,
      grupo_obleas: values.grupo_obleas.map((item) => item.id),
    }
    await interfaces.interfaceTypeVehicle
      .updateVehicle(id, body)
      .then((res) => {
        createDismissableSnackbar(res.data, {
          variant: 'success',
        })
        changeRender()
      })
      .catch((error) =>
        createDismissableSnackbar(error.response.data.data, {
          variant: 'error',
        })
      )
      .finally(handleclose)
    setIsLoading(false)
  }

  const GRUPO_OBLEAS = [
    {
      id: 'APC',
      tipo: 'APC',
    },
    {
      id: 'C',
      tipo: 'C',
    },
    {
      id: 'NO_APLICA',
      tipo: 'No aplica',
    },
  ]

  const object = (values, setFieldValue) => [
    {
      class: 'textfield',
      label: 'Nombre',
      name: 'nombre',
      value: values.nombre,
      sm: 12,
      xs: 12,
    },
    {
      class: 'textfield',
      label: 'Descripción',
      name: 'descripcion',
      value: values.descripcion,
      sm: 12,
      xs: 12,
    },
    {
      class: 'custom',
      component: (
        <MultiAutocomplete
          name="grupo_obleas"
          options={GRUPO_OBLEAS}
          getOptionLabel={(e) => e.tipo}
          value={values.grupo_obleas}
          label="Grupo de obleas"
          onChange={(_, value) => {
            setFieldValue('grupo_obleas', value)
          }}
          tagName="tipo"
          heightInput="auto"
        />
      ),
      sm: 12,
      xs: 12,
    },
  ]

  const children = () => {
    const inicialGrupo = Array.isArray(info.grupo_obleas)
      ? GRUPO_OBLEAS.filter((opt) => info.grupo_obleas.includes(opt.id))
      : []
    return (
      <Formik
        onSubmit={onSubmit}
        initialValues={{
          nombre: info.nombre,
          descripcion: info.descripcion,
          grupo_obleas: inicialGrupo,
        }}
      >
        {({ setFieldValue, isSubmitting, values }) => (
          <Form>
            <InputsWithValidate
              fields={object(values, setFieldValue)}
              spacing={2}
              setFieldValue={setFieldValue}
              isSubmitting={isSubmitting}
            />
            <button style={{ display: 'none' }} type="submit" ref={formSubmitRef} />
          </Form>
        )}
      </Formik>
    )
  }
  return (
    <DialogComponent
      title="Editar tipo de vehículo"
      open={open}
      handleclose={handleclose}
      children={children()}
      disableChildHeight
      disableBackdropClick
      disableEscapeKeyDown
      actions={
        <CancelConfirmButtons
          onClickSubmit={handleSubmit}
          onClickCancel={handleclose}
          isLoading={isLoading}
          disabledCancel={isLoading}
          disabledSubmit={isLoading}
        />
      }
    />
  )
}

export default Edit
